// @ts-ignore Reading config from public/config.js
export const API_URL = process.env.REACT_APP_API_URL || window.REACT_APP_API_URL

if (!API_URL) {
  throw new Error(
    'No API_URL defined, set REACT_APP_API_URL env variable or provide in /config.js'
  )
}
